import {
  Box,
  Divider,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  TextField,
  TextareaAutosize,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import { IoTicketSharp } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import LoadingButton from "@mui/lab/LoadingButton";
import OpenTickets from "../components/support/OpenTickets";
import axios from "axios";
import { BASE_URL } from "../utils/BaseURL";
import WaitingTickets from "../components/support/WaitingTickets";
import ClosedTickets from "../components/support/ClosedTickets";

const Support = () => {
  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [description, setDescription] = useState("");
  const [activeTab, setActiveTab] = useState("Open");
  const [flag, setFlag] = useState(false);
  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    orderId: "",
  });
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleDescription = () => {
    setShowDescription(!showDescription);
    setDescription("");
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = () => {
    setLoading(true);
    let data = {
      orderId: formData.orderId,
      userId: user?._id,
      description: description,
    };

    axios
      .post(`${BASE_URL}/tickets/create`, data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((res) => {
        if (res?.status == 200) {
          console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        handleDrawerClose();
        setFlag(!flag);
      });
  };
  return (
    <Box margin={"20px"}>
      <Box className="col">
        {/* Main Container */}
        <Box p={"5px"}>
          {/* Info Heading */}
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="h6" fontWeight={"bold"}>
                Support
              </Typography>
              <Typography fontSize={"11px"}>
                Get help by creating a ticket or reading help articles
              </Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                style={{ backgroundColor: "#9333E9" }}
                onClick={handleDrawerOpen}
              >
                Create Ticket
              </Button>
            </Box>
          </Box>
          {/* Links */}
          <Grid container display={"flex"} mt={"20px"} gap={"20px"}>
            <Grid>
              <Box
                borderRadius={"5px"}
                border={"2px solid #9333E9"}
                p="12px 60px"
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"5px"}
                boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px"}
                style={{ cursor: "pointer" }}
              >
                <Box
                  style={{
                    backgroundColor: "#FFEEEE",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                >
                  <IoTicketSharp style={{ color: "red" }} fontSize="medium" />
                </Box>
                <Typography fontWeight={"bold"} color={"#2A007C"}>
                  Tickets
                </Typography>
              </Box>
            </Grid>
          </Grid>
          {/* Tabs */}
          <Box display="flex" mt="50px" gap="20px">
            <Button
              variant={activeTab === "Open" ? "contained" : "text"}
              style={{
                backgroundColor:
                  activeTab === "Open" ? "#9333E9" : "transparent",
                color: activeTab === "Open" ? "white" : "black",
                fontWeight: "bold",
              }}
              onClick={() => handleTabClick("Open")}
            >
              Open
            </Button>
            <Button
              variant={activeTab === "Waiting" ? "contained" : "text"}
              style={{
                backgroundColor:
                  activeTab === "Waiting" ? "#9333E9" : "transparent",
                color: activeTab === "Waiting" ? "white" : "black",
                fontWeight: "bold",
              }}
              onClick={() => handleTabClick("Waiting")}
            >
              Awaiting Response
            </Button>
            <Button
              variant={activeTab === "Close" ? "contained" : "text"}
              style={{
                backgroundColor:
                  activeTab === "Close" ? "#9333E9" : "transparent",
                color: activeTab === "Close" ? "white" : "black",
                fontWeight: "bold",
              }}
              onClick={() => handleTabClick("Close")}
            >
              Closed
            </Button>
          </Box>
          <Divider style={{ marginTop: "10px" }} />
          <Box mt={"20px"}>
            {activeTab === "Open" && <OpenTickets status="Open" flag={flag} />}
            {activeTab === "Waiting" && (
              <WaitingTickets status="Waiting" flag={flag} />
            )}
            {activeTab === "Close" && (
              <ClosedTickets status="Closed" flag={flag} />
            )}
          </Box>
          {/* Drawer */}
          <Drawer anchor="right" open={open} onClose={handleDrawerClose}>
            <div style={{ padding: "10px 20px", width: "60vw" }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Box>
                  <Typography variant="h6" fontWeight={"bold"}>
                    Create Ticket
                  </Typography>
                  <Typography fontSize={"11px"}>
                    Create a ticket by entering the following details
                  </Typography>
                </Box>
                <Box>
                  <IoMdClose
                    color="black"
                    onClick={handleDrawerClose}
                    style={{ cursor: "pointer" }}
                  />
                </Box>
              </Box>
              <Divider style={{ marginTop: "5px" }} />
              <Box mt={"30px"}>
                <form>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel required>Category</InputLabel>
                        <Select
                          labelId="demo-simple-select-required-label"
                          name="category"
                          value={formData.category}
                          label="Category *"
                          // onChange={handleCategoryChange}
                          width="100%"
                        >
                          {categoryOptions.map((category) => (
                          <MenuItem key={category} value={category}>
                            {category}
                          </MenuItem>
                        ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Sub-category</InputLabel>
                        <Select
                          required
                          name="subCategory"
                          value={formData.subCategory}
                          onChange={handleSubCategoryChange}
                          disabled={!formData.category}
                          label="Sub-category *"
                        >
                          {subCategoryOptions[formData.category]?.map(
                          (subCategory) => (
                            <MenuItem key={subCategory} value={subCategory}>
                              {subCategory}
                            </MenuItem>
                          )
                        )}
                        </Select>
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        label="Enter Your Order Number"
                        name="orderId"
                        value={formData.orderId}
                        onChange={handleInputChange}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {showDescription && (
                        <TextareaAutosize
                          placeholder="Enter Description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          style={{
                            width: "100%",
                            height: "50px",
                            border: "1px solid #ccc",
                            paddingLeft: "10px",
                            borderRadius: "2px",
                          }}
                        />
                      )}
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#9333E9",
                          //   padding: "10px 10px",
                        }}
                        onClick={toggleDescription}
                      >
                        {showDescription
                          ? "Hide Description"
                          : "Add Description"}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      {loading ? (
                        <LoadingButton
                          loading
                          variant="contained"
                          style={
                            {
                              // padding: "10px 40px",
                            }
                          }
                        >
                          Submit
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#9333E9",
                            // padding: "10px 40px",
                          }}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </div>
          </Drawer>
        </Box>
      </Box>
    </Box>
  );
};

export default Support;
